import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Footer from '../../../Layout/Footer';
import Header from '../../../Layout/Header';
import feedback from '../../../../assets/img/notify.jpg';
import { Button } from 'react-bootstrap';
import moment from 'moment';
import { useEffect } from 'react';
import { useState } from 'react';
import { AssignBuyer, getAssignBuyer, getOfferBuyer } from '../../../../Redux/Task/action';
import { IMAGE_URL } from '../../../../api';
import ToasterMessage from '../../../ToasterMessage';
import SweetAlert from 'react-bootstrap-sweetalert';

const MytaskListingBuyer = () => {

    const [isloader, setIsloader] = useState(false);
    const [toaster, setToaster] = useState("");
    const [assign, setAssign] = useState([]);
    const [isswal, setIsswal] = useState({
        is_Active: false,
        id: ""
    });
    const navigate = useNavigate();
    const { state } = useLocation();
    const [tasks, setTasks] = useState([])
    useEffect(() => {
        getOfferBuyer(state?.data?.task_details ? state?.data?.task_details : state?.data?.id)((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });
    }, []);

    const onAssignBuyerSweetAlert = (id) => {
        setIsswal({
            is_Active: true,
            id,
        });
    }
    const onAssignBuyer = (task_offer = isswal.id) => {

        var task_details = state?.data?.task_details ? state?.data?.task_details : state?.data?.id;
        AssignBuyer({ task_offer, task_details })((response) => {
            if (response && response.status) {
                // getAssignedBuyer()

                navigate("/mytaskbuyer", { state: { toaster: true } })
            }
            else {

                setToaster("Low Balance")
                setTimeout(() => {
                    setToaster("")

                }, 2000);
            }

        });
    }
    // const getAssignedBuyer = () => {
    //     getAssignBuyer()((response) => {
    //         if (response && response.status) {
    //             setAssign(response?.data)
    //         }
    //     });
    // }
    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>My Task </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Task Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="mytask-details">
                <div className="container">
                    <div className="row task-details-main">
                        <div className='col-lg-6'>
                            <div className='border-right-task'>
                                <div className='task-details-flex'>
                                    <h5>{state?.data?.title}</h5>
                                    <p>Task price:<i class="bi bi-currency-rupee"></i>{state?.data?.task_price}</p>
                                </div>
                                <h6>Expiring on: {moment(state?.data?.date_choice).format('ll')}</h6>
                                {state?.data?.location == "" ?
                                    <></>
                                    :
                                    <p><i class="bi bi-geo-alt-fill"></i> {state?.data?.location}</p>
                                }
                                <div className='service-desc'>
                                    <h5>Service Description</h5>
                                    <p>{state?.data?.description}</p>
                                </div>
                            </div>

                        </div>
                        <div className='col-lg-6'>
                            <div className='offers'>
                                <div className='task-details-flex'>
                                    <h5>Offers({tasks?.length})</h5>
                                </div>

                                {tasks?.map((task, index) =>
                                    <div className='offers-link' >
                                        <div className="member">
                                            <div className="pic"><img src={IMAGE_URL + task?.image[0]?.image} className="img-fluid" alt="" /></div>
                                            <div className="member-info" onClick={() => navigate('/mytaskhistorybuyer', { state: { data: task } })}>
                                                <div className='task_title_main'>
                                                    <h4>{task?.user?.username}</h4>
                                                </div>
                                                {task?.chat_rate == "" ?
                                                    <React.Fragment>
                                                        <p>Bid rate: {task?.bid_rate}</p>
                                                    </React.Fragment>
                                                    :
                                                    <React.Fragment>
                                                        <p>Chat rate: {task?.chat_rate}</p>
                                                        <p>Call rate: {task?.call_rate}/{task?.time_field == 1 ? "hour" : task?.time_field == 2 && "min"}</p>
                                                    </React.Fragment>

                                                }

                                                <p> {task?.about_yourself}</p>
                                                {task?.average_rating == "" && task?.total_rating == "" ?
                                                    <></>
                                                    :
                                                    <span className="badge badge-light-warning">{parseFloat(task?.average_rating).toFixed(1)} <i class="bi bi-star-fill"></i> ( {task?.total_rating} )</span>
                                                }
                                            </div>
                                            <div className='assign-btn'>
                                                <Button className='offers-assignbtn mb-3' variant="primary" onClick={() => onAssignBuyerSweetAlert(task?.id)}>Assign</Button>
                                                {task?.amount_data?.final_amount == '' ?
                                                    <>
                                                        <span className="badge badge-light-success me-2 mb-2">Inclusive of all charges chat rate: {parseFloat(task?.amount_data?.final_chat_rate).toFixed(2)}</span>
                                                        <span className="badge badge-light-success me-2 ">Inclusive of all charges call rate : {parseFloat(task?.amount_data?.final_call_rate).toFixed(2)}/{task?.time_field == 1 ? "hour" : task?.time_field == 2 && "min"}</span>
                                                    </>
                                                    :
                                                    <span className="badge badge-light-success me-2">Inclusive of all charges : {parseFloat(task?.amount_data?.final_amount).toFixed(2)}</span>
                                                }

                                            </div>

                                        </div>

                                        {isswal.is_Active &&
                                            <SweetAlert
                                                showCancel
                                                reverseButtons={true}
                                                confirmBtnText="Yes, assign it!"
                                                confirmBtnBsStyle="danger"
                                                title="Are you sure?"
                                                onConfirm={() => onAssignBuyer()}
                                                onCancel={() => {
                                                    setIsswal({
                                                        is_Active: false,
                                                        id: "",
                                                    });
                                                }}
                                                closeOnClickOutside={false}
                                                focusCancelBtn

                                            >
                                            </SweetAlert>
                                        }
                                    </div>

                                )}

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default MytaskListingBuyer;